<template>
  <svg
    id="User-Increase--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <desc>User Increase Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M3.914 4a3 3 0 1 0 6 0 3 3 0 1 0 -6 0"
      fill="currentColor"
      stroke-width="1"
    />
    <path
      d="M16.914 5a4 4 0 0 0 -4 4h8a4 4 0 0 0 -4 -4z"
      fill="currentColor"
      stroke-width="1"
    />
    <path
      d="M14.914 2a2 2 0 1 0 4 0 2 2 0 1 0 -4 0"
      fill="currentColor"
      stroke-width="1"
    />
    <path
      d="M2.441 13h8.945a0.5 0.5 0 0 0 0.5 -0.556 5 5 0 0 0 -9.939 0 0.5 0.5 0 0 0 0.124 0.389 0.5 0.5 0 0 0 0.37 0.167z"
      fill="currentColor"
      stroke-width="1"
    />
    <path
      d="M15 11v2h3.586L12 19.586l-4.293 -4.293a1 1 0 0 0 -1.414 0l-5 5 1.414 1.414L7 17.414l4.293 4.293a1 1 0 0 0 1.414 0L20 14.414V18h2v-7z"
      fill="currentColor"
      stroke-width="1"
    />
  </svg>
</template>
